import { GroupSecurity } from '@quromedical/fhir-common';
import type {
  GroupGetAllParams,
  GroupGetAllResponse,
} from '@quromedical/models';
import { CrudForm } from 'components/form';
import { WithGroup } from 'core/auth';
import {
  CreateGroupCard,
  columnsLarge,
  initialSearch,
  searchFields,
  type TableGroup,
} from 'core/group';
import { PaginatedTable } from 'core/table';
import { Section, ToggleCard } from 'design-system';
import { router } from 'expo-router';
import type { FetcherOptions } from 'hooks/usePaginatedData';
import { GroupApi } from 'integration/aggregate';
import type { GroupStackScreenProps } from 'navigation';
import type React from 'react';
import { useCallback, useState } from 'react';
import { ScrollView } from 'react-native';
import { strings } from 'strings';

const api = new GroupApi();

const getDataFromResponse = (res: GroupGetAllResponse): TableGroup[] =>
  res.groups;

export const GroupListScreen: React.FC<GroupStackScreenProps<'List'>> = () => {
  const [search, setSearch] = useState<GroupGetAllParams>(initialSearch);

  const fetcher = useCallback(
    (options?: FetcherOptions) =>
      api.getGroups({
        pageToken: options?.nextToken,
        code: search.code,
        ...options,
      }),
    [search.code],
  );

  const onRowPress = useCallback(
    (row: TableGroup) =>
      router.push({
        pathname: `/admin/group/${row.id}`,
      }),
    [],
  );

  return (
    <ScrollView>
      <WithGroup groups={[GroupSecurity.GroupCreate]}>
        <Section unsetZIndex>
          <ToggleCard
            icon="people-outline"
            title={strings.GroupToggleCardTitle}
            textExpand={strings.GroupToggleCardExpandButtonText}
            textCollapse={strings.GroupToggleCardCollapseButtonText}
            contentWrapperProps={{ paddingHorizontal: 0, paddingVertical: 0 }}
          >
            <CreateGroupCard />
          </ToggleCard>
        </Section>
      </WithGroup>
      <Section unsetZIndex>
        <CrudForm
          cardProps={{ unsetZIndex: true }}
          fields={searchFields}
          initialValues={initialSearch}
          showSubmitButton={false}
          onChange={setSearch}
        />
      </Section>
      <Section unsetZIndex>
        <PaginatedTable
          cacheKey={`Group${JSON.stringify(search)}`}
          fetcher={fetcher}
          onRowPress={onRowPress}
          columns={columnsLarge}
          getDataFromResponse={getDataFromResponse}
        />
      </Section>
    </ScrollView>
  );
};
